import { useAuth } from '../../contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    // Redirect to login page with return url
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/auth?redirect=${encodeURIComponent(returnTo)}`} replace />;
  }

  return children;
};

export default ProtectedRoute; 